import { Stack, colors, rem, useLang } from '@manulife/mux';
import { Conversation, Login2 } from '@manulife/mux-cds-icons';
import Labels from "../../assets/labels";
import { FooterBtnLabel } from '../../assets/appStyledComponents';
import NumberConstants from "../../assets/appStyledComponents/numberConstant.json";
import './RtgPageFooter.css';

export default function RtgPageFooter() {
    const {num40} = NumberConstants;
    const selectedLang = useLang();
    const styles = {
        outline: {
            backgroundColor: colors.dark_1_green,
            width: '100%',
            alignItems: "stretch",
            justifyContent: 'center'
        },
        placeholder: {
            border: `solid 1px ${colors.light_4_dark_navy}`,
            backgroundColor: colors.dark_1_green,
            padding: rem(num40),
            width: "49%",
            flexGrow: 1,
            justifyContent: `center`,
            textAlign: "center",
            cursor: "pointer"
        },
    };

    const onHover = (e) => {
        e.currentTarget.style.backgroundColor = colors.dark_2_green;
        e.currentTarget.style.border = `solid 1px ${colors.white}`;
    };
    const offHover = (e) => {
        e.currentTarget.style.backgroundColor = colors.dark_1_green;
        e.currentTarget.style.border = `solid 1px ${colors.light_4_dark_navy}`;
    };

    return (
        <Stack direction="row" gap="0" style={{ ...styles.outline }}>
            <a
                href={Labels.contactUs[selectedLang].url}
                target="_blank" rel="noopener noreferrer"
                className="footer-link"
                data-testid={`footerBtnContact`}
                style={{...styles.placeholder, textDecoration: 'none', color: colors.white, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}
                onClick={() => window.open(Labels.contactUs[selectedLang].url)}
                onKeyDown={event => {
                    if (event.key === 'Enter' || event.key ===' ') {
                        window.open(Labels.contactUs[selectedLang].url)
                    }
                }}
                onMouseOver={onHover}
                onFocus={onHover}
                onMouseOut={offHover}
                onBlur={offHover}
                aria-label={Labels.contactUs[selectedLang].externalLinkText}
            >
                <Conversation color={colors.white} fontSize={rem(num40)} />
                <FooterBtnLabel>{Labels.contactUs[selectedLang].label}</FooterBtnLabel>
            </a>
            <a
                href={Labels.contactYourWholesaler[selectedLang].url}
                target="_blank" rel="noopener noreferrer"
                className="footer-link"
                data-testid={`footerBtnAdvisor`}
                style={{...styles.placeholder, textDecoration: 'none', color: colors.white, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}
                onClick={() => window.open(Labels.contactYourWholesaler[selectedLang].url)}
                onKeyDown={event => {
                    if (event.key === 'Enter' || event.key ===' ') {
                        window.open(Labels.contactYourWholesaler[selectedLang].url)
                    }
                }}
                onMouseOver={onHover}
                onFocus={onHover}
                onMouseOut={offHover}
                onBlur={offHover}
                aria-label={Labels.contactYourWholesaler[selectedLang].externalLinkText}
            >
                <Login2 color={colors.white} fontSize={rem(num40)}/>
                <FooterBtnLabel>{Labels.contactYourWholesaler[selectedLang].label}</FooterBtnLabel>
            </a>
        </Stack>
    );
};
